import { ENumberHighlightType } from "@/common/number-highlight/number-highlight-models";
import { cn } from "@/utils/cn";
import { renderIf } from "@/utils/react-conditional";
import React from "react";

export interface IMenuItemRightProps {
  type: ENumberHighlightType;
  number: number | string;
  isDisabled?: boolean;
  inlineStyle?: React.CSSProperties;
  color?: string;
  children?: React.ReactNode;
}

export const NumberHighlight = React.memo(function NumberHighlight(
  props: IMenuItemRightProps
) {
  const isLeft = props.type === ENumberHighlightType.Left;
  const isCreditRate = props.type === ENumberHighlightType.CreditRate;

  return (
    <div
      style={props.inlineStyle}
      className={cn("flex items-center justify-center", {
        "flex-col": props.type === ENumberHighlightType.Top,
        "flex-row": isLeft || isCreditRate,
      })}
    >
      <div
        className={cn(
          "text-center leading-[normal] not-italic",
          isLeft || isCreditRate ? "text-[30px]" : "text-heading-lg/[inherit]",
          isCreditRate ? "font-medium" : "font-bold",
          props.isDisabled
            ? "text-[#bbbbbb]"
            : isCreditRate
              ? "text-title-color"
              : "text-text-strong"
        )}
        style={props.color ? { color: props.color } : undefined}
      >
        {props.number}
      </div>
      <div
        className={cn(
          "text-micro leading-[normal] font-medium not-italic",
          isLeft ? "ml-0.75 text-left" : "text-center",
          props.isDisabled ? "text-[#bbbbbb]" : "text-text-strong"
        )}
        style={props.color ? { color: props.color } : undefined}
      >
        {renderIf(isCreditRate, {
          ifTrue: () => (
            <>
              <div className="mt-0.5 ml-px text-center text-[13px] leading-[normal] font-medium text-body-text not-italic">
                CREDITS
              </div>
              <div className="-mt-1 ml-px text-center text-small leading-[normal] font-normal whitespace-nowrap text-text-muted not-italic">
                /<span className="tracking-[-0.1em]"> </span>50 chars
              </div>
            </>
          ),
          ifFalse: () => props.children,
        })}
      </div>
    </div>
  );
});
